import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'
import { ConnectedPlatformStatus } from 'src/models/transaction.models'
import { css } from 'styled-components'

const checkboxRowCss = css`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  ${getFontCss(
    14,
    themeConstants.colors.font_primary,
    styleConstants.fontFamilies.regular,
  )};
`

interface ReceiptSyncStatusFilterProps {
  receiptAttachmentSyncStatusesSet: Set<string>
  handleReceiptAttachmentSyncStatusesSelection: (status: string) => Set<string>
}

const ReceiptSyncStatusFilter: React.FC<ReceiptSyncStatusFilterProps> = ({
  receiptAttachmentSyncStatusesSet,
  handleReceiptAttachmentSyncStatusesSelection,
}) => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        {translate('Receipt Sync')}
      </div>
      <label css={checkboxRowCss}>
        <Checkbox
          checked={receiptAttachmentSyncStatusesSet.has(
            ConnectedPlatformStatus.Success,
          )}
          onChange={(): void => {
            handleReceiptAttachmentSyncStatusesSelection(
              ConnectedPlatformStatus.Success,
            )
          }}
          aria-label={translate('Synced')}
        />
        {translate('Synced')}
      </label>
      <label css={checkboxRowCss}>
        <Checkbox
          checked={receiptAttachmentSyncStatusesSet.has(
            ConnectedPlatformStatus.NotSynced,
          )}
          onChange={(): void => {
            handleReceiptAttachmentSyncStatusesSelection(
              ConnectedPlatformStatus.NotSynced,
            )
          }}
          aria-label={translate('Not synced')}
        />
        {translate('Not synced')}
      </label>
      <label css={checkboxRowCss}>
        <Checkbox
          checked={receiptAttachmentSyncStatusesSet.has(
            ConnectedPlatformStatus.Failed,
          )}
          onChange={(): void => {
            handleReceiptAttachmentSyncStatusesSelection(
              ConnectedPlatformStatus.Failed,
            )
          }}
          aria-label={translate('Sync failed')}
        />
        {translate('Sync failed')}
      </label>
      <label css={checkboxRowCss}>
        <Checkbox
          checked={receiptAttachmentSyncStatusesSet.has(
            ConnectedPlatformStatus.Pending,
          )}
          onChange={(): void => {
            handleReceiptAttachmentSyncStatusesSelection(
              ConnectedPlatformStatus.Pending,
            )
          }}
          aria-label={translate('Sync in progress')}
        />
        {translate('Sync in progress')}
      </label>
    </div>
  )
}

export default ReceiptSyncStatusFilter
